import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

import Header from './Header';
import Footer from './Footer';
import Stempel from './Stempel';
// import ScrollToTop from './ScrollToTop'; 


const Layout = () => {

  useEffect(() => {
    const handleCopy = (e: ClipboardEvent) => {
      const selection = window.getSelection()?.toString();

      // Не добавляем ссылку для коротких фрагментов
      if (!selection || selection.length < 42) {
        return;
      }

      const text =
        selection +
        '\n\n━━━━━━━━━━━━━\n' +
        'Официальный сайт Сергея Мавроди:\n' +
        window.location.href;

      e.clipboardData?.setData('text/plain', text);
      e.preventDefault();
    };

    document.addEventListener('copy', handleCopy);

    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>Официальный сайт Сергея Мавроди</title>

        <meta name="description" content="Официальный сайт Сергея Мавроди: музей, законность, новости, творчество, видео, книги и архивные материалы." />
        <meta name="keywords" content="Сергей Мавроди, МММ, KinoTheater, музей, законность, новости, творчество, видео, книги" />
        <meta name="author" content="sergey-mavrodi.com" />

        {/* <!-- Open Graph для соцсетей --> */}
        <meta property="og:title" content="Официальный сайт Сергея Мавроди" />
        <meta property="og:description" content="Новости, музей, законность, творчество, видео, книги и архивные материалы Сергея Мавроди." />
        <meta property="og:image" content="/portrait.webp" />
        <meta property="og:url" content="https://sergey-mavrodi.com" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ru_RU" />

        {/* <!-- Twitter Cards --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Официальный сайт Сергея Мавроди" />
        <meta name="twitter:description" content="Новости, музей, законность, творчество, видео, книги и архивные материалы Сергея Мавроди." />
        <meta name="twitter:image" content="/portrait.webp" />

        <link rel="canonical" href="https://sergey-mavrodi.com/" />

        <script type="application/ld+json">
          {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Официальный сайт Сергея Мавроди",
        "url": "https://sergey-mavrodi.com",
        "image": "https://sergey-mavrodi.com/portrait.webp",
        "description": "Официальный сайт Сергея Мавроди. Новости, музей, законность, творчество, видео, книги, статьи и архивные материалы.",
        "sameAs": [
          "https://vimeo.com/mavrodi",
          "https://rutube.ru/channel/39271788/",
          "https://youtube.com/@kinotheaterluzifer"
        ],
        "author": {
          "@type": "Person",
          "name": "Сергей Мавроди",
          "description": "Основатель МММ, писатель и общественный деятель",
          "sameAs": [
            "https://vimeo.com/mavrodi",
            "https://rutube.ru/channel/39271788/",
            "https://youtube.com/@kinotheaterluzifer"
          ]
        },
            'breadcrumb': {
              '@type': 'BreadcrumbList',
              'itemListElement': [
                {
                  '@type': 'ListItem',
                  'position': 1,
                  'name': 'Главная',
                  'item': 'https://sergey-mavrodi.com/',
                },
              ],
            },
          })}
        </script>
      </Helmet>

      <Header />
      <main>
        <Stempel>
          <Outlet />
        </Stempel>
      </main>
      <Footer />
      {/* <ScrollToTop /> */}
    </div>
  );
};

export default Layout;